import { useEffect } from 'react';
// store
import { CircularProgress } from '@mui/material';
import { useAuthStore } from '@stores/authStore';
// components
import { DetermineLayout } from '@layouts/DetermineLayout/DetermineLayout';
import { UnauthorizedLayout } from '@layouts/UnauthorizedLayout/UnauthorizedLayout';
// utils
import { envWindowReplaceCallback } from '@utils/envWindowReplaceCallback';

export const ProtectedRoute = () => {
  const { pathname, search } = window.location;
  const authSession = useAuthStore((state) => state.authSession);
  const initializedUser = useAuthStore((state) => state.initializedUser);
  const signIn = useAuthStore((state) => state.signIn);
  const getMe = useAuthStore((state) => state.getMe);

  const signInCallback: VoidFunction = () => {
    signIn(pathname, search);
  };

  useEffect(() => {
    void getMe();
  }, []);

  // Redirect guardian users to Family Connect
  if (initializedUser && authSession.isAuthenticated && authSession.preferences?.appMode === 'Guardian') {
    envWindowReplaceCallback('https://brightpath.youscience.com/family-connect');
    return null;
  }

  return authSession.isAuthenticated ? (
    <DetermineLayout access={authSession.currentAccess.role || 'Learner'} isImpersonated={authSession.isImpersonated} />
  ) : (
    <UnauthorizedLayout signIn={initializedUser ? signInCallback : undefined}>
      <CircularProgress size={60} />
    </UnauthorizedLayout>
  );
};
